import { ApplicationInsights } from '@microsoft/applicationinsights-web';

/**
 * Base URL for newhire-api (must end with `/v1` — same as main.go `/{API_VERSION}/newhires/...`).
 * Always same host as the SPA (`window.location.origin`), e.g. gateway serves `/v1` on the same origin.
 * Relative `/v1` when `window` is absent (Node/tests).
 */
function getNewhireApiBaseUrl(): string {
    if (typeof window !== 'undefined' && window.location?.origin) {
        return `${window.location.origin}/v1`;
    }
    return '/v1';
}

export const API = {
    NEWHIRE_URL: getNewhireApiBaseUrl(),
};

export const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: 'f6a31db4-7877-487e-af13-41eb52ec6d1f',
    },
});

appInsights.loadAppInsights();
